"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AddressResultRow_1 = require("./AddressResultRow");
var AddressResults = function (_a) {
    var results = _a.results, searchTerm = _a.searchTerm, findOrRetrieve = _a.findOrRetrieve, trackAddress = _a.trackAddress, hideResults = _a.hideResults, setResultClicked = _a.setResultClicked;
    return results ? (React.createElement("div", { className: 'results-wrapper' },
        React.createElement("fieldset", { name: 'address_search_results', role: 'controlgroup' },
            React.createElement("legend", null, "Address search results"),
            results.Items.map(function (result, i) { return (React.createElement(AddressResultRow_1.default, { key: i, i: i, result: result, hideResults: hideResults, findOrRetrieve: findOrRetrieve, trackAddress: trackAddress, setResultClicked: setResultClicked })); })))) : (React.createElement("div", { className: 'results-wrapper' },
        React.createElement("div", { className: 'result-row small' },
            React.createElement("p", { className: 'label' }, "Searching for results"))));
};
exports.default = AddressResults;
